export default {
  example: 'example',
};
